import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Version-index-1992f2b8ce14be471-1'),
    routerUrl: '/Version',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Version')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Version-index-1992f2b8ce14be471-2'),
        routerUrl: '/VersionForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./VersionForm')),
      },
      //$MORE$
    ],
  },
];
